import React from 'react'
import { Box, Switch, Typography } from '@mui/material'

interface SettingsSwitchRowProps {
  title: string
  data: boolean
  onChange?: (value: boolean) => void
  loading?: boolean
}

function SettingsSwitchRow({ title, data, onChange, loading }: SettingsSwitchRowProps) {
  return (
    <Box display="flex" alignItems="center" justifyContent="space-between">
      <Typography sx={{ fontWeight: '300' }}>{title}</Typography>
      <Switch
        checked={data}
        onChange={(e) => (onChange ? onChange(e.target.checked) : null)}
        color="primary"
        disabled={loading}
      />
    </Box>
  )
}

export default SettingsSwitchRow
